module.exports = __webpack_public_path__ + "static/media/terrariaLogo.742aae8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ServersList/Server/images/terrariaLogo.jpg
// module id = 316
// module chunks = 0